export default __webpack_public_path__ + "static/media/balance-bike.68b57c91.mp4";